// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Google Reviews – analytics dashboard
   All dashboard rules are scoped with the \`gr-\` prefix (CRA styles are global).
   ========================================================================== */

.gr-root {
  --gr-bg: #f6f6f3;
  --gr-surface: #ffffff;
  --gr-surface-2: #f9f9f7;
  --gr-border: rgba(11, 11, 11, 0.09);
  --gr-border-strong: rgba(11, 11, 11, 0.16);
  --gr-text: #151514;
  --gr-text-2: #52514e;
  --gr-muted: #7d7b75;
  --gr-accent: #2a78d6;
  --gr-accent-soft: rgba(42, 120, 214, 0.1);
  --gr-positive: #2a78d6;
  --gr-neutral: #a3a19a;
  --gr-negative: #e34948;
  --gr-negative-text: #c0392b;
  --gr-positive-text: #1c5cab;
  --gr-good: #006300;
  --gr-warn: #8a5a00;
  --gr-warn-bg: #fff6e0;
  --gr-star: #f2b01e;
  --gr-radius: 12px;
  --gr-radius-sm: 8px;
  --gr-shadow: 0 1px 2px rgba(11, 11, 11, 0.04), 0 1px 1px rgba(11, 11, 11, 0.03);
  --gr-gap: 16px;

  max-width: 1480px;
  margin: 0 auto;
  padding: 24px;
  min-height: 100vh;
  background: var(--gr-bg);
  color: var(--gr-text);
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  font-size: 14px;
  line-height: 1.45;
  box-sizing: border-box;
}

.gr-root *,
.gr-root *::before,
.gr-root *::after {
  box-sizing: border-box;
}

.gr-root button {
  font: inherit;
  color: inherit;
}

.gr-root button:focus-visible,
.gr-root select:focus-visible,
.gr-root input:focus-visible,
.gr-root tr:focus-visible {
  outline: 2px solid var(--gr-accent);
  outline-offset: 2px;
}

.gr-muted { color: var(--gr-muted); }
.gr-nowrap { white-space: nowrap; }
.gr-text-negative { color: var(--gr-negative-text); }
.gr-text-positive { color: var(--gr-positive-text); }
.gr-rotate { transform: rotate(180deg); }

/* ---------- Header ---------- */
.gr-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 16px;
}

.gr-header > div { min-width: 0; }

.gr-header h1 {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.gr-header p {
  margin: 4px 0 0;
  color: var(--gr-text-2);
}

.gr-header-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  text-align: right;
  font-size: 13px;
  color: var(--gr-text-2);
}

.gr-header-meta strong {
  font-size: 18px;
  color: var(--gr-text);
  font-variant-numeric: tabular-nums;
}

/* ---------- Sticky filter bar + tabs ---------- */
.gr-sticky {
  position: sticky;
  top: 0;
  z-index: 20;
  margin: 0 -24px 20px;
  padding: 12px 24px 0;
  background: rgba(246, 246, 243, 0.94);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--gr-border);
}

.gr-filterbar {
  display: flex;
  align-items: center;
  gap: 12px;
}

.gr-periods {
  display: inline-flex;
  padding: 3px;
  gap: 2px;
  background: var(--gr-surface);
  border: 1px solid var(--gr-border);
  border-radius: 10px;
  overflow-x: auto;
  scrollbar-width: none;
  max-width: 100%;
}

.gr-periods::-webkit-scrollbar { display: none; }

.gr-periods button,
.gr-segmented button {
  border: 0;
  background: transparent;
  padding: 7px 12px;
  border-radius: 7px;
  white-space: nowrap;
  cursor: pointer;
  color: var(--gr-text-2);
  font-weight: 500;
  transition: background 0.15s, color 0.15s;
}

.gr-periods button:hover,
.gr-segmented button:hover { background: var(--gr-surface-2); color: var(--gr-text); }

.gr-periods button.is-active,
.gr-segmented button.is-active {
  background: var(--gr-text);
  color: #fff;
}

/* The period presets may scroll horizontally; the "Filtry" button always stays visible on the right. */
.gr-periods { flex: 0 1 auto; min-width: 0; }
.gr-filter-toggle { flex: 0 0 auto; margin-left: auto; }

.gr-filter-fields-sheet {
  display: grid;
  gap: 12px;
}

.gr-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.gr-field > span {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--gr-muted);
}

.gr-field select,
.gr-field input {
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--gr-border-strong);
  border-radius: var(--gr-radius-sm);
  background: var(--gr-surface);
  color: var(--gr-text);
  font: inherit;
  min-width: 0;
  max-width: 220px;
}

.gr-field select:disabled { opacity: 0.55; }

.gr-field-inline {
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.gr-field-inline > span { white-space: nowrap; }


.gr-custom-range {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.gr-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
}

.gr-active-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid rgba(42, 120, 214, 0.35);
  background: var(--gr-accent-soft);
  color: #184f95 !important;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gr-active-chip:hover { background: rgba(42, 120, 214, 0.18); }

.gr-tabs {
  display: flex;
  gap: 4px;
  margin-top: 12px;
  overflow-x: auto;
  scrollbar-width: none;
}

.gr-tabs::-webkit-scrollbar { display: none; }

.gr-tabs button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--gr-text-2);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.gr-tabs button:hover { color: var(--gr-text); }

.gr-tabs button.is-active {
  color: var(--gr-accent);
  border-bottom-color: var(--gr-accent);
}

.gr-progress {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 2px;
  overflow: hidden;
}

.gr-progress::after {
  content: "";
  position: absolute;
  inset: 0;
  width: 35%;
  background: var(--gr-accent);
  animation: gr-progress 1s ease-in-out infinite;
}

@keyframes gr-progress {
  from { transform: translateX(-100%); }
  to { transform: translateX(300%); }
}

/* ---------- Buttons ---------- */
.gr-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: var(--gr-radius-sm);
  border: 1px solid transparent;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
}

.gr-btn:disabled { opacity: 0.5; cursor: default; }

.gr-btn-primary { background: var(--gr-text); color: #fff !important; }
.gr-btn-primary:hover { background: #33332f; }

.gr-btn-ghost {
  background: var(--gr-surface);
  border-color: var(--gr-border-strong);
}

.gr-btn-ghost:hover:not(:disabled) { background: var(--gr-surface-2); }

.gr-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--gr-radius-sm);
  border: 1px solid transparent;
  background: transparent;
  color: var(--gr-muted) !important;
  cursor: pointer;
}

.gr-icon-btn:hover { background: var(--gr-surface-2); color: var(--gr-text) !important; border-color: var(--gr-border); }

.gr-link-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--gr-accent) !important;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}

.gr-link-btn:hover { text-decoration: underline; }

.gr-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--gr-accent);
  color: #fff;
  font-size: 11px;
}

/* ---------- Layout ---------- */
.gr-content { transition: opacity 0.2s; }
.gr-content.is-loading { opacity: 0.6; }

.gr-tab {
  display: flex;
  flex-direction: column;
  gap: var(--gr-gap);
}

.gr-grid {
  display: grid;
  gap: var(--gr-gap);
  align-items: start;
}

.gr-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.gr-grid-7-5 { grid-template-columns: minmax(0, 7fr) minmax(0, 5fr); }
.gr-grid-8-4 { grid-template-columns: minmax(0, 8fr) minmax(0, 4fr); }

.gr-card {
  background: var(--gr-surface);
  border: 1px solid var(--gr-border);
  border-radius: var(--gr-radius);
  box-shadow: var(--gr-shadow);
  padding: 18px 20px 20px;
  min-width: 0;
}

.gr-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}

.gr-card-titles { min-width: 0; }

.gr-card-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 650;
}

.gr-card-header p {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: var(--gr-muted);
}

.gr-card-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.gr-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.gr-toolbar-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--gr-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.gr-segmented {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border-radius: 10px;
  background: var(--gr-surface);
  border: 1px solid var(--gr-border);
}

/* ---------- KPI ---------- */
.gr-kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--gr-gap);
}

.gr-kpi {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 18px 12px;
  background: var(--gr-surface);
  border: 1px solid var(--gr-border);
  border-radius: var(--gr-radius);
  box-shadow: var(--gr-shadow);
  min-width: 0;
  overflow: hidden;
}

.gr-kpi::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: transparent;
}

.gr-kpi-positive::before { background: var(--gr-positive); }
.gr-kpi-negative::before { background: var(--gr-negative); }

.gr-kpi-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--gr-text-2);
}

.gr-kpi-main {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.gr-kpi-value {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.1;
}

.gr-kpi-suffix {
  font-size: 14px;
  color: var(--gr-muted);
  font-weight: 500;
}

.gr-kpi-foot {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 8px;
  font-size: 12px;
  min-height: 20px;
}

.gr-kpi-hint { color: var(--gr-muted); }

.gr-sparkline {
  margin: 4px -4px 0;
  height: 36px;
}

.gr-delta {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.gr-delta-good { color: var(--gr-good); background: rgba(12, 163, 12, 0.1); }
.gr-delta-bad { color: var(--gr-negative-text); background: rgba(227, 73, 72, 0.1); }
.gr-delta-flat { color: var(--gr-muted); background: var(--gr-surface-2); }

.gr-ministats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  background: var(--gr-surface);
  border: 1px solid var(--gr-border);
  border-radius: var(--gr-radius);
  box-shadow: var(--gr-shadow);
}

.gr-ministat {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 18px;
  min-width: 0;
}

.gr-ministat + .gr-ministat { border-left: 1px solid var(--gr-border); }

.gr-ministat-label {
  font-size: 12px;
  color: var(--gr-text-2);
  font-weight: 600;
}

.gr-ministat-value {
  font-size: 20px;
  font-weight: 700;
}

.gr-ministat-hint {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 12px;
  color: var(--gr-muted);
}

/* ---------- Stars ---------- */
.gr-stars {
  position: relative;
  display: inline-block;
  line-height: 1;
  letter-spacing: 1px;
  white-space: nowrap;
}

.gr-stars-md { font-size: 16px; }
.gr-stars-sm { font-size: 13px; }

.gr-stars-base { color: #dedcd5; }

.gr-stars-fill {
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  color: var(--gr-star);
}

/* ---------- Insights ---------- */
.gr-insights {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.gr-insights li > button,
.gr-insights li > div {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--gr-border);
  border-radius: var(--gr-radius-sm);
  background: var(--gr-surface);
  text-align: left;
}

.gr-insights li > button { cursor: pointer; transition: border-color 0.15s, background 0.15s; }
.gr-insights li > button:hover { border-color: rgba(42, 120, 214, 0.4); background: var(--gr-surface-2); }

.gr-insight-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  flex-shrink: 0;
}

.gr-insight-positive { background: rgba(42, 120, 214, 0.12); color: #1c5cab; }
.gr-insight-negative { background: rgba(227, 73, 72, 0.12); color: var(--gr-negative-text); }
.gr-insight-warning { background: var(--gr-warn-bg); color: var(--gr-warn); }
.gr-insight-info { background: var(--gr-surface-2); color: var(--gr-text-2); }

.gr-insight-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}

.gr-insight-body strong { font-size: 13.5px; }
.gr-insight-body span { font-size: 12.5px; color: var(--gr-text-2); }

.gr-insight-arrow {
  color: var(--gr-muted);
  align-self: center;
  flex-shrink: 0;
}

/* ---------- Rating distribution ---------- */
.gr-ratings {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.gr-ratings button {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 48px 78px;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 6px;
  border: 0;
  border-radius: var(--gr-radius-sm);
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.gr-ratings button:hover { background: var(--gr-surface-2); }

.gr-ratings-label { font-weight: 600; white-space: nowrap; }
.gr-ratings-label span { color: var(--gr-star); }

.gr-ratings-track {
  height: 10px;
  border-radius: 999px;
  background: #efeee9;
  overflow: hidden;
}

.gr-ratings-track span {
  display: block;
  height: 100%;
  border-radius: 999px;
  min-width: 2px;
}

.gr-ratings-value {
  text-align: right;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.gr-ratings-pct {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-variant-numeric: tabular-nums;
  color: var(--gr-text-2);
  line-height: 1.2;
}

.gr-ratings-pct small { font-size: 11px; color: var(--gr-muted); white-space: nowrap; }

/* ---------- Charts ---------- */
.gr-chart { width: 100%; min-width: 0; }

.gr-chart .recharts-wrapper,
.gr-chart .recharts-surface { overflow: visible; }

.gr-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 8px;
  font-size: 12px;
  color: var(--gr-text-2);
}

.gr-legend span,
.gr-sentbar-legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.gr-legend i,
.gr-sentbar-legend i,
.gr-donut-legend i,
.gr-tooltip-row i {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex-shrink: 0;
}

.gr-tooltip {
  min-width: 170px;
  padding: 10px 12px;
  background: var(--gr-surface);
  border: 1px solid var(--gr-border-strong);
  border-radius: var(--gr-radius-sm);
  box-shadow: 0 8px 24px rgba(11, 11, 11, 0.12);
  font-size: 12.5px;
}

.gr-tooltip-title {
  font-weight: 650;
  margin-bottom: 6px;
}

.gr-tooltip-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 1px 0;
  color: var(--gr-text-2);
}

.gr-tooltip-row span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.gr-tooltip-row strong {
  color: var(--gr-text);
  font-variant-numeric: tabular-nums;
}

.gr-tooltip-hint {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid var(--gr-border);
  font-size: 11.5px;
  color: var(--gr-muted);
}

/* ---------- Donut ---------- */
.gr-donut-chart { position: relative; }

.gr-donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.gr-donut-center strong { font-size: 26px; font-weight: 700; line-height: 1; }
.gr-donut-center span { font-size: 12px; color: var(--gr-muted); }

.gr-donut-legend {
  list-style: none;
  margin: 10px 0 0;
  padding: 0;
}

.gr-donut-legend button {
  display: grid;
  grid-template-columns: 14px 1fr auto 52px;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 6px;
  border: 0;
  border-radius: var(--gr-radius-sm);
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.gr-donut-legend button:hover { background: var(--gr-surface-2); }
.gr-donut-legend strong { font-variant-numeric: tabular-nums; }
.gr-donut-legend small { text-align: right; color: var(--gr-muted); font-variant-numeric: tabular-nums; }

.gr-donut-foot {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--gr-border);
  font-size: 12.5px;
  color: var(--gr-text-2);
}

/* ---------- Bar lists ---------- */
.gr-barlist {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.gr-barlist button {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  padding: 8px 8px;
  border: 0;
  border-radius: var(--gr-radius-sm);
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.gr-barlist button:disabled { cursor: default; }
.gr-barlist button:hover:not(:disabled) { background: var(--gr-surface-2); }

.gr-barlist-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
}

.gr-barlist-label {
  font-weight: 550;
  min-width: 0;
  overflow-wrap: anywhere;
}

.gr-barlist-value {
  font-weight: 650;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.gr-barlist-value small {
  font-weight: 400;
  color: var(--gr-muted);
  font-size: 11.5px;
}

.gr-barlist-track {
  height: 8px;
  border-radius: 999px;
  background: #efeee9;
  overflow: hidden;
}

.gr-barlist-fill {
  display: block;
  height: 100%;
  border-radius: 999px;
  min-width: 3px;
}

.gr-barlist-secondary {
  font-size: 12px;
  color: var(--gr-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ---------- Sentiment bar ---------- */
.gr-sentbar-wrap { display: flex; flex-direction: column; gap: 4px; min-width: 90px; }

.gr-sentbar {
  display: flex;
  gap: 2px;
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  background: #efeee9;
}

.gr-sentbar span { display: block; height: 100%; min-width: 3px; }

.gr-sentbar-legend {
  display: flex;
  gap: 10px;
  font-size: 11.5px;
  color: var(--gr-text-2);
}

/* ---------- Tables ---------- */
.gr-table-wrap {
  width: 100%;
  overflow-x: auto;
}

.gr-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.gr-table th {
  padding: 8px 10px;
  text-align: left;
  font-size: 11.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--gr-muted);
  border-bottom: 1px solid var(--gr-border-strong);
  white-space: nowrap;
}

.gr-table th button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: inherit !important;
  text-transform: inherit;
  letter-spacing: inherit;
  cursor: pointer;
}

.gr-table th button:hover { color: var(--gr-text) !important; }

.gr-table td {
  padding: 10px;
  border-bottom: 1px solid var(--gr-border);
  vertical-align: middle;
}

.gr-table .is-num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.gr-table th.is-num button { flex-direction: row-reverse; }
.gr-table td.is-primary { font-weight: 600; }
.gr-table tr.is-clickable { cursor: pointer; }
.gr-table tbody tr.is-clickable:hover { background: var(--gr-surface-2); }
.gr-table tbody tr:last-child td { border-bottom: 0; }

.gr-cell-stack {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.gr-rating-cell { font-weight: 600; white-space: nowrap; }

.gr-share-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.gr-share-track {
  width: 60px;
  height: 6px;
  border-radius: 999px;
  background: #efeee9;
  overflow: hidden;
}

.gr-share-track span {
  display: block;
  height: 100%;
  background: var(--gr-negative);
}

.gr-person {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* ---------- Products ---------- */
.gr-products {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.gr-products button {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 6px 12px;
  width: 100%;
  padding: 10px 8px;
  border: 0;
  border-radius: var(--gr-radius-sm);
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.gr-products button:hover { background: var(--gr-surface-2); }
.gr-products-name { font-weight: 600; }
.gr-products-stats { font-size: 12.5px; color: var(--gr-text-2); white-space: nowrap; }
.gr-products .gr-sentbar-wrap { grid-column: 1 / -1; }

/* ---------- Departments ---------- */
.gr-dept-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px;
}

.gr-dept {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  border: 1px solid var(--gr-border);
  border-radius: var(--gr-radius);
  background: var(--gr-surface);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.gr-dept:hover { border-color: rgba(42, 120, 214, 0.45); box-shadow: 0 4px 14px rgba(11, 11, 11, 0.06); }

.gr-dept-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
}

.gr-dept-head strong { font-size: 14.5px; }
.gr-dept-head span { font-size: 12px; color: var(--gr-muted); white-space: nowrap; }

.gr-dept-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.gr-dept-metrics > span {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 14px;
}

.gr-dept-metrics small {
  font-size: 11px;
  font-weight: 500;
  color: var(--gr-muted);
}

.gr-dept-foot {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  color: var(--gr-text-2);
}

/* ---------- Reviews ---------- */
.gr-reviews-toolbar {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.gr-reviews-controls {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: auto;
}

.gr-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 320px;
  min-width: 0;
  height: 40px;
  padding: 0 10px;
  gap: 8px;
  border: 1px solid var(--gr-border-strong);
  border-radius: var(--gr-radius-sm);
  background: var(--gr-surface);
  color: var(--gr-muted);
}

.gr-search:focus-within { border-color: var(--gr-accent); box-shadow: 0 0 0 3px var(--gr-accent-soft); }

.gr-search input {
  flex: 1 1;
  min-width: 0;
  height: 100%;
  border: 0;
  outline: none;
  background: transparent;
  font: inherit;
  color: var(--gr-text);
}

.gr-search button {
  display: inline-flex;
  padding: 4px;
  border: 0;
  background: none;
  cursor: pointer;
  color: var(--gr-muted) !important;
}

.gr-search-sm { height: 32px; flex: 0 1 220px; }

.gr-quick-toggles {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.gr-quick-toggles button {
  padding: 5px 12px;
  border-radius: 999px;
  border: 1px solid var(--gr-border-strong);
  background: var(--gr-surface);
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
}

.gr-quick-toggles button:hover { background: var(--gr-surface-2); }

.gr-quick-toggles button.is-active {
  background: var(--gr-text);
  border-color: var(--gr-text);
  color: #fff !important;
}

.gr-results-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  color: var(--gr-text-2);
}

.gr-review-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: opacity 0.2s;
}

.gr-review-list.is-loading { opacity: 0.55; }

.gr-review-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.gr-review {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  background: var(--gr-surface);
  border: 1px solid var(--gr-border);
  border-left: 3px solid var(--gr-border);
  border-radius: var(--gr-radius);
  min-width: 0;
}

.gr-review-negatywna { border-left-color: var(--gr-negative); }
.gr-review-pozytywna { border-left-color: var(--gr-positive); }
.gr-review-neutralna { border-left-color: var(--gr-neutral); }

.gr-review-head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.gr-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e8eef7;
  color: #1c5cab;
  font-weight: 700;
  flex-shrink: 0;
}

.gr-avatar-sm { width: 26px; height: 26px; font-size: 12px; }

.gr-review-who {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}

.gr-review-who strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gr-review-who span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--gr-muted);
}

.gr-review-score {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
}

.gr-badge {
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.gr-badge-pozytywna { background: rgba(42, 120, 214, 0.12); color: #1c5cab; }
.gr-badge-negatywna { background: rgba(227, 73, 72, 0.12); color: var(--gr-negative-text); }
.gr-badge-neutralna { background: var(--gr-surface-2); color: var(--gr-text-2); border: 1px solid var(--gr-border); }

.gr-review-text {
  margin: 0;
  white-space: pre-line;
  overflow-wrap: anywhere;
  color: var(--gr-text);
}

.gr-review-text.is-clamped {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.gr-review-text mark {
  background: #fff1b8;
  color: inherit;
  padding: 0 1px;
  border-radius: 2px;
}

.gr-review .gr-link-btn { margin-top: -6px; align-self: flex-start; }

.gr-review-chips,
.gr-review-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.gr-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 12px;
  cursor: pointer;
}

.gr-chip-positive { background: rgba(42, 120, 214, 0.08); color: #1c5cab !important; }
.gr-chip-negative { background: rgba(227, 73, 72, 0.08); color: var(--gr-negative-text) !important; }
.gr-chip:hover { border-color: currentColor; }

.gr-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid var(--gr-border);
  background: var(--gr-surface-2);
  font-size: 11.5px;
  color: var(--gr-text-2) !important;
}

button.gr-tag { cursor: pointer; }
button.gr-tag:hover { border-color: var(--gr-border-strong); color: var(--gr-text) !important; }

.gr-tag-person { background: #eef3fb; }
.gr-tag-urgency-wysoki { background: rgba(227, 73, 72, 0.1); color: var(--gr-negative-text) !important; border-color: transparent; }
.gr-tag-urgency-sredni,
.gr-tag-warn { background: var(--gr-warn-bg); color: var(--gr-warn) !important; border-color: transparent; }

.gr-reply {
  padding-top: 8px;
  border-top: 1px dashed var(--gr-border-strong);
}

.gr-reply .gr-link-btn { margin-top: 0; }

.gr-reply p {
  margin: 8px 0 0;
  padding: 10px 12px;
  border-radius: var(--gr-radius-sm);
  background: var(--gr-surface-2);
  font-size: 13px;
  color: var(--gr-text-2);
  white-space: pre-line;
}

/* ---------- Pagination ---------- */
.gr-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}

.gr-pagination button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  padding: 0 8px;
  border-radius: var(--gr-radius-sm);
  border: 1px solid var(--gr-border-strong);
  background: var(--gr-surface);
  cursor: pointer;
  font-variant-numeric: tabular-nums;
}

.gr-pagination button:disabled { opacity: 0.4; cursor: default; }
.gr-pagination button.is-active { background: var(--gr-text); border-color: var(--gr-text); color: #fff !important; }
.gr-pagination-gap { padding: 0 4px; color: var(--gr-muted); }
.gr-pagination-compact { display: none; padding: 0 8px; color: var(--gr-text-2); }

/* ---------- States ---------- */
.gr-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 32px 16px;
  text-align: center;
  color: var(--gr-muted);
}

.gr-empty strong { color: var(--gr-text-2); }
.gr-empty p { margin: 0; max-width: 420px; }
.gr-empty .gr-btn { margin-top: 8px; }

.gr-alert {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 14px;
  margin-bottom: 16px;
  border-radius: var(--gr-radius-sm);
}

.gr-alert .gr-btn { margin-left: auto; height: 30px; }
.gr-alert-error { background: #fdecec; color: #8f1d1d; border: 1px solid #f5c2c2; }

.gr-fatal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  max-width: 480px;
  margin: 80px auto;
  padding: 32px;
  text-align: center;
  background: var(--gr-surface);
  border: 1px solid var(--gr-border);
  border-radius: var(--gr-radius);
  color: var(--gr-negative-text);
}

.gr-fatal h2 { margin: 0; font-size: 18px; color: var(--gr-text); }
.gr-fatal p { margin: 0 0 8px; color: var(--gr-text-2); }

.gr-skel,
.gr-skeleton-list {
  border-radius: var(--gr-radius);
  background: linear-gradient(90deg, #ecebe6 0%, #f5f4f0 50%, #ecebe6 100%);
  background-size: 200% 100%;
  animation: gr-shimmer 1.2s linear infinite;
}

.gr-page-skeleton { display: flex; flex-direction: column; gap: 16px; }
.gr-skel-header { height: 56px; width: 40%; }
.gr-skel-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
.gr-skel-kpi { height: 120px; }
.gr-skel-chart { height: 320px; }
.gr-skeleton-list { height: 220px; }

@keyframes gr-shimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

/* ---------- Mobile filter sheet ---------- */
.gr-sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(11, 11, 11, 0.4);
}

.gr-sheet {
  width: 100%;
  max-width: 560px;
  max-height: 88vh;
  overflow-y: auto;
  padding: 16px 16px calc(16px + env(safe-area-inset-bottom));
  background: var(--gr-surface);
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -8px 30px rgba(11, 11, 11, 0.18);
  animation: gr-sheet-in 0.2s ease-out;
}

@keyframes gr-sheet-in {
  from { transform: translateY(24px); opacity: 0; }
  to { transform: none; opacity: 1; }
}

.gr-sheet-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
}

.gr-sheet .gr-field select,
.gr-sheet .gr-field input {
  max-width: none;
  height: 44px;
  font-size: 16px; /* prevents iOS zoom on focus */
}

.gr-sheet-foot {
  position: sticky;
  bottom: calc(-16px - env(safe-area-inset-bottom));
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px;
  margin: 16px -16px 0;
  padding: 12px 16px;
  background: var(--gr-surface);
  border-top: 1px solid var(--gr-border);
}

.gr-sheet-foot .gr-btn { height: 44px; }

@media (min-width: 1101px) {
  .gr-sheet-backdrop { align-items: center; }
  .gr-sheet { border-radius: 16px; max-width: 480px; }
  .gr-sheet-foot { position: static; margin-bottom: -16px; border-radius: 0 0 16px 16px; }
}

/* ==========================================================================
   Responsive
   ========================================================================== */
@media (max-width: 1100px) {
  .gr-grid-7-5,
  .gr-grid-8-4 { grid-template-columns: minmax(0, 1fr); }
  .gr-kpis { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .gr-ministats { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .gr-ministat:nth-child(3) { border-left: 0; }
  .gr-ministat:nth-child(n + 3) { border-top: 1px solid var(--gr-border); }
}

@media (max-width: 760px) {
  .gr-root { padding: 16px; font-size: 14px; }
  .gr-sticky { margin: 0 -16px 16px; padding: 10px 16px 0; }

  .gr-header { flex-direction: column; align-items: flex-start; gap: 8px; }
  .gr-header h1 { font-size: 22px; }
  .gr-header .gr-nowrap { white-space: normal; }
  .gr-header-meta { align-items: flex-start; text-align: left; }

  .gr-grid-2 { grid-template-columns: minmax(0, 1fr); }
  .gr-review-grid { grid-template-columns: minmax(0, 1fr); }

  .gr-filterbar { gap: 8px; }
  .gr-filter-toggle { padding: 0 10px; }
  .gr-periods button { padding: 7px 10px; }
  .gr-tabs button { padding: 10px 10px; }

  .gr-card { padding: 14px 14px 16px; }
  .gr-kpi { padding: 14px 14px 10px; }
  .gr-kpi-value { font-size: 24px; }
  .gr-ministat { padding: 10px 14px; }
  .gr-ministat-value { font-size: 18px; }

  .gr-reviews-controls { margin-left: 0; width: 100%; justify-content: space-between; }
  .gr-search { flex-basis: 100%; height: 44px; }
  .gr-search input { font-size: 16px; }
  .gr-quick-toggles { flex-wrap: nowrap; overflow-x: auto; scrollbar-width: none; margin: 0 -16px; padding: 0 16px; }
  .gr-quick-toggles::-webkit-scrollbar { display: none; }
  .gr-quick-toggles button { white-space: nowrap; padding: 7px 12px; }

  .gr-review { padding: 14px; }
  .gr-pagination button:not(:first-child):not(:last-child) { display: none; }
  .gr-pagination-gap { display: none; }
  .gr-pagination-compact { display: inline; }
  .gr-pagination button { min-width: 44px; height: 44px; }

  .gr-custom-range .gr-field { flex: 1 1 140px; }
  .gr-custom-range .gr-field input { max-width: none; flex: 1 1; font-size: 16px; }

  /* Tables become stacked cards. */
  .gr-table thead { display: none; }
  .gr-table,
  .gr-table tbody,
  .gr-table tr,
  .gr-table td { display: block; width: 100%; }
  .gr-table tr {
    padding: 10px 0;
    border-bottom: 1px solid var(--gr-border);
  }
  .gr-table tbody tr:last-child { border-bottom: 0; }
  .gr-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 3px 4px;
    border: 0;
    text-align: right;
  }
  .gr-table td::before {
    content: attr(data-label);
    flex-shrink: 0;
    font-size: 12px;
    color: var(--gr-muted);
    text-align: left;
  }
  .gr-table td.is-primary { font-size: 14.5px; padding-bottom: 6px; }
  .gr-table td.is-primary::before { display: none; }
  .gr-table td .gr-sentbar-wrap { flex: 0 1 160px; }
  .gr-cell-stack { flex-direction: row; align-items: center; gap: 6px; }

  .gr-card-header { flex-wrap: wrap; }
  .gr-card-header .gr-search-sm { flex: 1 1 100%; }
  .gr-card-actions:has(.gr-search-sm) { width: 100%; }

  .gr-skel-row { grid-template-columns: repeat(2, 1fr); }
  .gr-skel-header { width: 70%; }
}

@media (max-width: 420px) {
  .gr-kpis { gap: 10px; }
  .gr-kpi-value { font-size: 22px; }
  .gr-ratings button { grid-template-columns: 30px minmax(0, 1fr) 34px 78px; gap: 8px; }
  .gr-dept-grid { grid-template-columns: minmax(0, 1fr); }
}

@media (prefers-reduced-motion: reduce) {
  .gr-root *,
  .gr-root *::after { animation: none !important; transition: none !important; }
}

/* ==========================================================================
   Shared legacy rules – these class names are also used by other pages
   (Surveys, FeedbackManagement, MeetingStatistics, AdminAnnouncements, Home,
   InstallationPlanning, ToolAnalytics, AdminPanel, AttachmentPreview).
   Kept unchanged so removing the old dashboard does not restyle them.
   ========================================================================== */
.subtitle {
  margin: 0.5rem 0 0;
  opacity: 0.9;
  font-size: 1.1rem;
}

.filter-actions {
  display: flex;
  align-items: flex-end;
}

.kpi-value {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0.25rem 0;
}

.kpi-label {
  font-size: 0.875rem;
  color: #9ca3af;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #e5e7eb;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-spinner p {
  margin-top: 1rem;
  color: #6b7280;
  font-weight: 600;
}

.error-message {
  background: #fee;
  border: 2px solid #f66;
  padding: 2rem;
  border-radius: 12px;
  text-align: center;
  max-width: 500px;
  margin: 2rem auto;
}

.error-message h3 {
  color: #dc2626;
  margin: 0 0 1rem;
}

.error-message p {
  color: #991b1b;
  margin: 0 0 1rem;
}

/* Recharts defaults shared by every chart in the portal */
.recharts-cartesian-axis-tick-value {
  font-size: 0.75rem;
  fill: #6b7280;
}

.recharts-legend-item-text {
  font-size: 0.875rem;
  color: #374151 !important;
}

.recharts-tooltip-wrapper {
  outline: none;
}

.recharts-default-tooltip {
  background: white !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  padding: 0.75rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/GoogleReviews.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;EACnC,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;EACzC,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,+EAA+E;EAC/E,cAAc;;EAEd,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,qEAAqE;EACrE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;;;EAIE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,YAAY,sBAAsB,EAAE;AACpC,aAAa,mBAAmB,EAAE;AAClC,oBAAoB,8BAA8B,EAAE;AACpD,oBAAoB,8BAA8B,EAAE;AACpD,aAAa,yBAAyB,EAAE;;AAExC,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA,mBAAmB,YAAY,EAAE;;AAEjC;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,qCAAqC;EACrC,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,QAAQ;EACR,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,iCAAiC,aAAa,EAAE;;AAEhD;;EAEE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;6BAC6B,+BAA+B,EAAE,qBAAqB,EAAE;;AAErF;;EAEE,0BAA0B;EAC1B,WAAW;AACb;;AAEA,uGAAuG;AACvG,cAAc,cAAc,EAAE,YAAY,EAAE;AAC5C,oBAAoB,cAAc,EAAE,iBAAiB,EAAE;;AAEvD;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA,4BAA4B,aAAa,EAAE;;AAE3C;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,0BAA0B,mBAAmB,EAAE;;;AAG/C;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,wBAAwB,oCAAoC,EAAE;;AAE9D;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,8BAA8B,aAAa,EAAE;;AAE7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,wBAAwB,qBAAqB,EAAE;;AAE/C;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,2BAA2B,EAAE;AACpC;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA,mBAAmB,YAAY,EAAE,eAAe,EAAE;;AAElD,kBAAkB,0BAA0B,EAAE,sBAAsB,EAAE;AACtE,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,qCAAqC,+BAA+B,EAAE;;AAEtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;AACjB;;AAEA,qBAAqB,+BAA+B,EAAE,gCAAgC,EAAE,8BAA8B,EAAE;;AAExH;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,qBAAqB,0BAA0B,EAAE;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,4BAA4B;EAC5B,WAAW;EACX,eAAe;AACjB;;AAEA,iCAAiC;AACjC,cAAc,wBAAwB,EAAE;AACxC,yBAAyB,YAAY,EAAE;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,aAAa,gDAAgD,EAAE;AAC/D,eAAe,oDAAoD,EAAE;AACrE,eAAe,oDAAoD,EAAE;;AAErE;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA,kBAAkB,YAAY,EAAE;;AAEhC;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA,2BAA2B,8BAA8B,EAAE;AAC3D,2BAA2B,8BAA8B,EAAE;;AAE3D;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe,sBAAsB,EAAE;;AAEvC;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,iBAAiB,qBAAqB,EAAE,kCAAkC,EAAE;AAC5E,gBAAgB,8BAA8B,EAAE,kCAAkC,EAAE;AACpF,iBAAiB,sBAAsB,EAAE,+BAA+B,EAAE;;AAE1E;EACE,aAAa;EACb,gDAAgD;EAChD,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA,8BAA8B,uCAAuC,EAAE;;AAEvE;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,eAAe,eAAe,EAAE;AAChC,eAAe,eAAe,EAAE;;AAEhC,iBAAiB,cAAc,EAAE;;AAEjC;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,2BAA2B,eAAe,EAAE,gDAAgD,EAAE;AAC9F,iCAAiC,qCAAqC,EAAE,+BAA+B,EAAE;;AAEzG;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uBAAuB,oCAAoC,EAAE,cAAc,EAAE;AAC7E,uBAAuB,mCAAmC,EAAE,8BAA8B,EAAE;AAC5F,sBAAsB,6BAA6B,EAAE,qBAAqB,EAAE;AAC5E,mBAAmB,+BAA+B,EAAE,uBAAuB,EAAE;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA,0BAA0B,iBAAiB,EAAE;AAC7C,wBAAwB,iBAAiB,EAAE,uBAAuB,EAAE;;AAEpE;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B,+BAA+B,EAAE;;AAE5D,oBAAoB,gBAAgB,EAAE,mBAAmB,EAAE;AAC3D,yBAAyB,qBAAqB,EAAE;;AAEhD;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,wBAAwB,eAAe,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;;AAEtF,iCAAiC;AACjC,YAAY,WAAW,EAAE,YAAY,EAAE;;AAEvC;8BAC8B,iBAAiB,EAAE;;AAEjD;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;EAIE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,yCAAyC;EACzC,kCAAkC;EAClC,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC,kBAAkB,kBAAkB,EAAE;;AAEtC;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,0BAA0B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC7E,wBAAwB,eAAe,EAAE,sBAAsB,EAAE;;AAEjE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC,+BAA+B,EAAE;AACjE,0BAA0B,kCAAkC,EAAE;AAC9D,yBAAyB,iBAAiB,EAAE,sBAAsB,EAAE,kCAAkC,EAAE;;AAExG;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B,eAAe,EAAE;AAC/C,0CAA0C,+BAA+B,EAAE;;AAE3E;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAErF;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mBAAmB,cAAc,EAAE,YAAY,EAAE,cAAc,EAAE;;AAEjE;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,4BAA4B,gCAAgC,EAAE;;AAE9D;EACE,aAAa;EACb,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,6BAA6B,2BAA2B,EAAE;AAC1D,0BAA0B,gBAAgB,EAAE;AAC5C,4BAA4B,eAAe,EAAE;AAC7C,wCAAwC,+BAA+B,EAAE;AACzE,mCAAmC,gBAAgB,EAAE;;AAErD;EACE,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA,kBAAkB,gBAAgB,EAAE,mBAAmB,EAAE;;AAEzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,4BAA4B,+BAA+B,EAAE;AAC7D,oBAAoB,gBAAgB,EAAE;AACtC,qBAAqB,iBAAiB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACtF,gCAAgC,mBAAmB,EAAE;;AAErD,sCAAsC;AACtC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA,iBAAiB,sCAAsC,EAAE,6CAA6C,EAAE;;AAExG;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,QAAQ;AACV;;AAEA,uBAAuB,iBAAiB,EAAE;AAC1C,qBAAqB,eAAe,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;;AAEnF;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,yCAAyC;EACzC,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,0BAA0B,8BAA8B,EAAE,2CAA2C,EAAE;;AAEvG;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA,gBAAgB,YAAY,EAAE,eAAe,EAAE;;AAE/C;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yCAAyC;EACzC,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iCAAiC,+BAA+B,EAAE;;AAElE;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;AAC1B;;AAEA,6BAA6B,aAAa,EAAE;;AAE5C;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,YAAY;AACd;;AAEA,uBAAuB,qCAAqC,EAAE;AAC9D,uBAAuB,qCAAqC,EAAE;AAC9D,uBAAuB,oCAAoC,EAAE;;AAE7D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB,oCAAoC,EAAE,cAAc,EAAE;AAC5E,sBAAsB,mCAAmC,EAAE,8BAA8B,EAAE;AAC3F,sBAAsB,+BAA+B,EAAE,uBAAuB,EAAE,kCAAkC,EAAE;;AAEpH;EACE,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA,0BAA0B,gBAAgB,EAAE,sBAAsB,EAAE;;AAEpE;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,eAAe;AACjB;;AAEA,oBAAoB,oCAAoC,EAAE,yBAAyB,EAAE;AACrF,oBAAoB,mCAAmC,EAAE,yCAAyC,EAAE;AACpG,iBAAiB,0BAA0B,EAAE;;AAE7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,gBAAgB,eAAe,EAAE;AACjC,sBAAsB,qCAAqC,EAAE,gCAAgC,EAAE;;AAE/F,iBAAiB,mBAAmB,EAAE;AACtC,yBAAyB,kCAAkC,EAAE,yCAAyC,EAAE,yBAAyB,EAAE;AACnI;eACe,6BAA6B,EAAE,gCAAgC,EAAE,yBAAyB,EAAE;;AAE3G;EACE,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,yBAAyB,aAAa,EAAE;;AAExC;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,yCAAyC;EACzC,6BAA6B;EAC7B,eAAe;EACf,kCAAkC;AACpC;;AAEA,iCAAiC,YAAY,EAAE,eAAe,EAAE;AAChE,kCAAkC,0BAA0B,EAAE,4BAA4B,EAAE,sBAAsB,EAAE;AACpH,qBAAqB,cAAc,EAAE,sBAAsB,EAAE;AAC7D,yBAAyB,aAAa,EAAE,cAAc,EAAE,uBAAuB,EAAE;;AAEjF,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,mBAAmB,uBAAuB,EAAE;AAC5C,cAAc,SAAS,EAAE,gBAAgB,EAAE;AAC3C,oBAAoB,eAAe,EAAE;;AAErC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,oBAAoB,iBAAiB,EAAE,YAAY,EAAE;AACrD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAElF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,eAAe,SAAS,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAClE,cAAc,eAAe,EAAE,uBAAuB,EAAE;;AAExD;;EAEE,+BAA+B;EAC/B,yEAAyE;EACzE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACtE,kBAAkB,YAAY,EAAE,UAAU,EAAE;AAC5C,eAAe,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;AAChF,eAAe,aAAa,EAAE;AAC9B,iBAAiB,aAAa,EAAE;AAChC,oBAAoB,aAAa,EAAE;;AAEnC;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,4BAA4B,EAAE;AACrC;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2DAA2D;EAC3D,6BAA6B;EAC7B,4BAA4B;EAC5B,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,eAAe,EAAE,UAAU,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,eAAe,EAAE,+BAA+B;AAClD;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA,yBAAyB,YAAY,EAAE;;AAEvC;EACE,qBAAqB,mBAAmB,EAAE;EAC1C,YAAY,mBAAmB,EAAE,gBAAgB,EAAE;EACnD,iBAAiB,gBAAgB,EAAE,oBAAoB,EAAE,4BAA4B,EAAE;AACzF;;AAEA;;+EAE+E;AAC/E;EACE;iBACe,qCAAqC,EAAE;EACtD,WAAW,gDAAgD,EAAE;EAC7D,gBAAgB,gDAAgD,EAAE;EAClE,4BAA4B,cAAc,EAAE;EAC5C,gCAAgC,sCAAsC,EAAE;AAC1E;;AAEA;EACE,WAAW,aAAa,EAAE,eAAe,EAAE;EAC3C,aAAa,oBAAoB,EAAE,oBAAoB,EAAE;;EAEzD,aAAa,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;EACxE,gBAAgB,eAAe,EAAE;EACjC,wBAAwB,mBAAmB,EAAE;EAC7C,kBAAkB,uBAAuB,EAAE,gBAAgB,EAAE;;EAE7D,aAAa,qCAAqC,EAAE;EACpD,kBAAkB,qCAAqC,EAAE;;EAEzD,gBAAgB,QAAQ,EAAE;EAC1B,oBAAoB,eAAe,EAAE;EACrC,qBAAqB,iBAAiB,EAAE;EACxC,kBAAkB,kBAAkB,EAAE;;EAEtC,WAAW,uBAAuB,EAAE;EACpC,UAAU,uBAAuB,EAAE;EACnC,gBAAgB,eAAe,EAAE;EACjC,eAAe,kBAAkB,EAAE;EACnC,qBAAqB,eAAe,EAAE;;EAEtC,uBAAuB,cAAc,EAAE,WAAW,EAAE,8BAA8B,EAAE;EACpF,aAAa,gBAAgB,EAAE,YAAY,EAAE;EAC7C,mBAAmB,eAAe,EAAE;EACpC,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,eAAe,EAAE,eAAe,EAAE;EAClH,uCAAuC,aAAa,EAAE;EACtD,2BAA2B,mBAAmB,EAAE,iBAAiB,EAAE;;EAEnE,aAAa,aAAa,EAAE;EAC5B,2DAA2D,aAAa,EAAE;EAC1E,qBAAqB,aAAa,EAAE;EACpC,yBAAyB,eAAe,EAAE;EAC1C,wBAAwB,eAAe,EAAE,YAAY,EAAE;;EAEvD,6BAA6B,eAAe,EAAE;EAC9C,mCAAmC,eAAe,EAAE,SAAO,EAAE,eAAe,EAAE;;EAE9E,iCAAiC;EACjC,kBAAkB,aAAa,EAAE;EACjC;;;iBAGe,cAAc,EAAE,WAAW,EAAE;EAC5C;IACE,eAAe;IACf,yCAAyC;EAC3C;EACA,gCAAgC,gBAAgB,EAAE;EAClD;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,gBAAgB;EAClB;EACA,0BAA0B,iBAAiB,EAAE,mBAAmB,EAAE;EAClE,kCAAkC,aAAa,EAAE;EACjD,gCAAgC,eAAe,EAAE;EACjD,iBAAiB,mBAAmB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;EAErE,kBAAkB,eAAe,EAAE;EACnC,gCAAgC,cAAc,EAAE;EAChD,sCAAsC,WAAW,EAAE;;EAEnD,eAAe,qCAAqC,EAAE;EACtD,kBAAkB,UAAU,EAAE;AAChC;;AAEA;EACE,WAAW,SAAS,EAAE;EACtB,gBAAgB,eAAe,EAAE;EACjC,qBAAqB,oDAAoD,EAAE,QAAQ,EAAE;EACrF,gBAAgB,qCAAqC,EAAE;AACzD;;AAEA;EACE;sBACoB,0BAA0B,EAAE,2BAA2B,EAAE;AAC/E;;AAEA;;;;;+EAK+E;AAC/E;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,6BAA6B;EAC7B,oDAAoD;EACpD,2BAA2B;AAC7B","sourcesContent":["/* ==========================================================================\n   Google Reviews – analytics dashboard\n   All dashboard rules are scoped with the `gr-` prefix (CRA styles are global).\n   ========================================================================== */\n\n.gr-root {\n  --gr-bg: #f6f6f3;\n  --gr-surface: #ffffff;\n  --gr-surface-2: #f9f9f7;\n  --gr-border: rgba(11, 11, 11, 0.09);\n  --gr-border-strong: rgba(11, 11, 11, 0.16);\n  --gr-text: #151514;\n  --gr-text-2: #52514e;\n  --gr-muted: #7d7b75;\n  --gr-accent: #2a78d6;\n  --gr-accent-soft: rgba(42, 120, 214, 0.1);\n  --gr-positive: #2a78d6;\n  --gr-neutral: #a3a19a;\n  --gr-negative: #e34948;\n  --gr-negative-text: #c0392b;\n  --gr-positive-text: #1c5cab;\n  --gr-good: #006300;\n  --gr-warn: #8a5a00;\n  --gr-warn-bg: #fff6e0;\n  --gr-star: #f2b01e;\n  --gr-radius: 12px;\n  --gr-radius-sm: 8px;\n  --gr-shadow: 0 1px 2px rgba(11, 11, 11, 0.04), 0 1px 1px rgba(11, 11, 11, 0.03);\n  --gr-gap: 16px;\n\n  max-width: 1480px;\n  margin: 0 auto;\n  padding: 24px;\n  min-height: 100vh;\n  background: var(--gr-bg);\n  color: var(--gr-text);\n  font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n  font-size: 14px;\n  line-height: 1.45;\n  box-sizing: border-box;\n}\n\n.gr-root *,\n.gr-root *::before,\n.gr-root *::after {\n  box-sizing: border-box;\n}\n\n.gr-root button {\n  font: inherit;\n  color: inherit;\n}\n\n.gr-root button:focus-visible,\n.gr-root select:focus-visible,\n.gr-root input:focus-visible,\n.gr-root tr:focus-visible {\n  outline: 2px solid var(--gr-accent);\n  outline-offset: 2px;\n}\n\n.gr-muted { color: var(--gr-muted); }\n.gr-nowrap { white-space: nowrap; }\n.gr-text-negative { color: var(--gr-negative-text); }\n.gr-text-positive { color: var(--gr-positive-text); }\n.gr-rotate { transform: rotate(180deg); }\n\n/* ---------- Header ---------- */\n.gr-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.gr-header > div { min-width: 0; }\n\n.gr-header h1 {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.gr-header p {\n  margin: 4px 0 0;\n  color: var(--gr-text-2);\n}\n\n.gr-header-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  text-align: right;\n  font-size: 13px;\n  color: var(--gr-text-2);\n}\n\n.gr-header-meta strong {\n  font-size: 18px;\n  color: var(--gr-text);\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---------- Sticky filter bar + tabs ---------- */\n.gr-sticky {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  margin: 0 -24px 20px;\n  padding: 12px 24px 0;\n  background: rgba(246, 246, 243, 0.94);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid var(--gr-border);\n}\n\n.gr-filterbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.gr-periods {\n  display: inline-flex;\n  padding: 3px;\n  gap: 2px;\n  background: var(--gr-surface);\n  border: 1px solid var(--gr-border);\n  border-radius: 10px;\n  overflow-x: auto;\n  scrollbar-width: none;\n  max-width: 100%;\n}\n\n.gr-periods::-webkit-scrollbar { display: none; }\n\n.gr-periods button,\n.gr-segmented button {\n  border: 0;\n  background: transparent;\n  padding: 7px 12px;\n  border-radius: 7px;\n  white-space: nowrap;\n  cursor: pointer;\n  color: var(--gr-text-2);\n  font-weight: 500;\n  transition: background 0.15s, color 0.15s;\n}\n\n.gr-periods button:hover,\n.gr-segmented button:hover { background: var(--gr-surface-2); color: var(--gr-text); }\n\n.gr-periods button.is-active,\n.gr-segmented button.is-active {\n  background: var(--gr-text);\n  color: #fff;\n}\n\n/* The period presets may scroll horizontally; the \"Filtry\" button always stays visible on the right. */\n.gr-periods { flex: 0 1 auto; min-width: 0; }\n.gr-filter-toggle { flex: 0 0 auto; margin-left: auto; }\n\n.gr-filter-fields-sheet {\n  display: grid;\n  gap: 12px;\n}\n\n.gr-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.gr-field > span {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--gr-muted);\n}\n\n.gr-field select,\n.gr-field input {\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid var(--gr-border-strong);\n  border-radius: var(--gr-radius-sm);\n  background: var(--gr-surface);\n  color: var(--gr-text);\n  font: inherit;\n  min-width: 0;\n  max-width: 220px;\n}\n\n.gr-field select:disabled { opacity: 0.55; }\n\n.gr-field-inline {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.gr-field-inline > span { white-space: nowrap; }\n\n\n.gr-custom-range {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.gr-chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.gr-active-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  border: 1px solid rgba(42, 120, 214, 0.35);\n  background: var(--gr-accent-soft);\n  color: #184f95 !important;\n  font-size: 12.5px;\n  font-weight: 500;\n  cursor: pointer;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gr-active-chip:hover { background: rgba(42, 120, 214, 0.18); }\n\n.gr-tabs {\n  display: flex;\n  gap: 4px;\n  margin-top: 12px;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.gr-tabs::-webkit-scrollbar { display: none; }\n\n.gr-tabs button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 14px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--gr-text-2);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.gr-tabs button:hover { color: var(--gr-text); }\n\n.gr-tabs button.is-active {\n  color: var(--gr-accent);\n  border-bottom-color: var(--gr-accent);\n}\n\n.gr-progress {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  height: 2px;\n  overflow: hidden;\n}\n\n.gr-progress::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  width: 35%;\n  background: var(--gr-accent);\n  animation: gr-progress 1s ease-in-out infinite;\n}\n\n@keyframes gr-progress {\n  from { transform: translateX(-100%); }\n  to { transform: translateX(300%); }\n}\n\n/* ---------- Buttons ---------- */\n.gr-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: var(--gr-radius-sm);\n  border: 1px solid transparent;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.gr-btn:disabled { opacity: 0.5; cursor: default; }\n\n.gr-btn-primary { background: var(--gr-text); color: #fff !important; }\n.gr-btn-primary:hover { background: #33332f; }\n\n.gr-btn-ghost {\n  background: var(--gr-surface);\n  border-color: var(--gr-border-strong);\n}\n\n.gr-btn-ghost:hover:not(:disabled) { background: var(--gr-surface-2); }\n\n.gr-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--gr-radius-sm);\n  border: 1px solid transparent;\n  background: transparent;\n  color: var(--gr-muted) !important;\n  cursor: pointer;\n}\n\n.gr-icon-btn:hover { background: var(--gr-surface-2); color: var(--gr-text) !important; border-color: var(--gr-border); }\n\n.gr-link-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 8px;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--gr-accent) !important;\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.gr-link-btn:hover { text-decoration: underline; }\n\n.gr-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--gr-accent);\n  color: #fff;\n  font-size: 11px;\n}\n\n/* ---------- Layout ---------- */\n.gr-content { transition: opacity 0.2s; }\n.gr-content.is-loading { opacity: 0.6; }\n\n.gr-tab {\n  display: flex;\n  flex-direction: column;\n  gap: var(--gr-gap);\n}\n\n.gr-grid {\n  display: grid;\n  gap: var(--gr-gap);\n  align-items: start;\n}\n\n.gr-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.gr-grid-7-5 { grid-template-columns: minmax(0, 7fr) minmax(0, 5fr); }\n.gr-grid-8-4 { grid-template-columns: minmax(0, 8fr) minmax(0, 4fr); }\n\n.gr-card {\n  background: var(--gr-surface);\n  border: 1px solid var(--gr-border);\n  border-radius: var(--gr-radius);\n  box-shadow: var(--gr-shadow);\n  padding: 18px 20px 20px;\n  min-width: 0;\n}\n\n.gr-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.gr-card-titles { min-width: 0; }\n\n.gr-card-header h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 650;\n}\n\n.gr-card-header p {\n  margin: 2px 0 0;\n  font-size: 12.5px;\n  color: var(--gr-muted);\n}\n\n.gr-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.gr-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.gr-toolbar-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--gr-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.gr-segmented {\n  display: inline-flex;\n  gap: 2px;\n  padding: 3px;\n  border-radius: 10px;\n  background: var(--gr-surface);\n  border: 1px solid var(--gr-border);\n}\n\n/* ---------- KPI ---------- */\n.gr-kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: var(--gr-gap);\n}\n\n.gr-kpi {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 16px 18px 12px;\n  background: var(--gr-surface);\n  border: 1px solid var(--gr-border);\n  border-radius: var(--gr-radius);\n  box-shadow: var(--gr-shadow);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.gr-kpi::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: transparent;\n}\n\n.gr-kpi-positive::before { background: var(--gr-positive); }\n.gr-kpi-negative::before { background: var(--gr-negative); }\n\n.gr-kpi-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--gr-text-2);\n}\n\n.gr-kpi-main {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.gr-kpi-value {\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n}\n\n.gr-kpi-suffix {\n  font-size: 14px;\n  color: var(--gr-muted);\n  font-weight: 500;\n}\n\n.gr-kpi-foot {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px 8px;\n  font-size: 12px;\n  min-height: 20px;\n}\n\n.gr-kpi-hint { color: var(--gr-muted); }\n\n.gr-sparkline {\n  margin: 4px -4px 0;\n  height: 36px;\n}\n\n.gr-delta {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 1px 6px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.gr-delta-good { color: var(--gr-good); background: rgba(12, 163, 12, 0.1); }\n.gr-delta-bad { color: var(--gr-negative-text); background: rgba(227, 73, 72, 0.1); }\n.gr-delta-flat { color: var(--gr-muted); background: var(--gr-surface-2); }\n\n.gr-ministats {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  background: var(--gr-surface);\n  border: 1px solid var(--gr-border);\n  border-radius: var(--gr-radius);\n  box-shadow: var(--gr-shadow);\n}\n\n.gr-ministat {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 12px 18px;\n  min-width: 0;\n}\n\n.gr-ministat + .gr-ministat { border-left: 1px solid var(--gr-border); }\n\n.gr-ministat-label {\n  font-size: 12px;\n  color: var(--gr-text-2);\n  font-weight: 600;\n}\n\n.gr-ministat-value {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.gr-ministat-hint {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  font-size: 12px;\n  color: var(--gr-muted);\n}\n\n/* ---------- Stars ---------- */\n.gr-stars {\n  position: relative;\n  display: inline-block;\n  line-height: 1;\n  letter-spacing: 1px;\n  white-space: nowrap;\n}\n\n.gr-stars-md { font-size: 16px; }\n.gr-stars-sm { font-size: 13px; }\n\n.gr-stars-base { color: #dedcd5; }\n\n.gr-stars-fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  color: var(--gr-star);\n}\n\n/* ---------- Insights ---------- */\n.gr-insights {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.gr-insights li > button,\n.gr-insights li > div {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--gr-border);\n  border-radius: var(--gr-radius-sm);\n  background: var(--gr-surface);\n  text-align: left;\n}\n\n.gr-insights li > button { cursor: pointer; transition: border-color 0.15s, background 0.15s; }\n.gr-insights li > button:hover { border-color: rgba(42, 120, 214, 0.4); background: var(--gr-surface-2); }\n\n.gr-insight-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.gr-insight-positive { background: rgba(42, 120, 214, 0.12); color: #1c5cab; }\n.gr-insight-negative { background: rgba(227, 73, 72, 0.12); color: var(--gr-negative-text); }\n.gr-insight-warning { background: var(--gr-warn-bg); color: var(--gr-warn); }\n.gr-insight-info { background: var(--gr-surface-2); color: var(--gr-text-2); }\n\n.gr-insight-body {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.gr-insight-body strong { font-size: 13.5px; }\n.gr-insight-body span { font-size: 12.5px; color: var(--gr-text-2); }\n\n.gr-insight-arrow {\n  color: var(--gr-muted);\n  align-self: center;\n  flex-shrink: 0;\n}\n\n/* ---------- Rating distribution ---------- */\n.gr-ratings {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.gr-ratings button {\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr) 48px 78px;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 7px 6px;\n  border: 0;\n  border-radius: var(--gr-radius-sm);\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n}\n\n.gr-ratings button:hover { background: var(--gr-surface-2); }\n\n.gr-ratings-label { font-weight: 600; white-space: nowrap; }\n.gr-ratings-label span { color: var(--gr-star); }\n\n.gr-ratings-track {\n  height: 10px;\n  border-radius: 999px;\n  background: #efeee9;\n  overflow: hidden;\n}\n\n.gr-ratings-track span {\n  display: block;\n  height: 100%;\n  border-radius: 999px;\n  min-width: 2px;\n}\n\n.gr-ratings-value {\n  text-align: right;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.gr-ratings-pct {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  font-variant-numeric: tabular-nums;\n  color: var(--gr-text-2);\n  line-height: 1.2;\n}\n\n.gr-ratings-pct small { font-size: 11px; color: var(--gr-muted); white-space: nowrap; }\n\n/* ---------- Charts ---------- */\n.gr-chart { width: 100%; min-width: 0; }\n\n.gr-chart .recharts-wrapper,\n.gr-chart .recharts-surface { overflow: visible; }\n\n.gr-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-top: 8px;\n  font-size: 12px;\n  color: var(--gr-text-2);\n}\n\n.gr-legend span,\n.gr-sentbar-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.gr-legend i,\n.gr-sentbar-legend i,\n.gr-donut-legend i,\n.gr-tooltip-row i {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.gr-tooltip {\n  min-width: 170px;\n  padding: 10px 12px;\n  background: var(--gr-surface);\n  border: 1px solid var(--gr-border-strong);\n  border-radius: var(--gr-radius-sm);\n  box-shadow: 0 8px 24px rgba(11, 11, 11, 0.12);\n  font-size: 12.5px;\n}\n\n.gr-tooltip-title {\n  font-weight: 650;\n  margin-bottom: 6px;\n}\n\n.gr-tooltip-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 1px 0;\n  color: var(--gr-text-2);\n}\n\n.gr-tooltip-row span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.gr-tooltip-row strong {\n  color: var(--gr-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.gr-tooltip-hint {\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid var(--gr-border);\n  font-size: 11.5px;\n  color: var(--gr-muted);\n}\n\n/* ---------- Donut ---------- */\n.gr-donut-chart { position: relative; }\n\n.gr-donut-center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.gr-donut-center strong { font-size: 26px; font-weight: 700; line-height: 1; }\n.gr-donut-center span { font-size: 12px; color: var(--gr-muted); }\n\n.gr-donut-legend {\n  list-style: none;\n  margin: 10px 0 0;\n  padding: 0;\n}\n\n.gr-donut-legend button {\n  display: grid;\n  grid-template-columns: 14px 1fr auto 52px;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 6px;\n  border: 0;\n  border-radius: var(--gr-radius-sm);\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n}\n\n.gr-donut-legend button:hover { background: var(--gr-surface-2); }\n.gr-donut-legend strong { font-variant-numeric: tabular-nums; }\n.gr-donut-legend small { text-align: right; color: var(--gr-muted); font-variant-numeric: tabular-nums; }\n\n.gr-donut-foot {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid var(--gr-border);\n  font-size: 12.5px;\n  color: var(--gr-text-2);\n}\n\n/* ---------- Bar lists ---------- */\n.gr-barlist {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.gr-barlist button {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  width: 100%;\n  padding: 8px 8px;\n  border: 0;\n  border-radius: var(--gr-radius-sm);\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n}\n\n.gr-barlist button:disabled { cursor: default; }\n.gr-barlist button:hover:not(:disabled) { background: var(--gr-surface-2); }\n\n.gr-barlist-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n}\n\n.gr-barlist-label {\n  font-weight: 550;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.gr-barlist-value {\n  font-weight: 650;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.gr-barlist-value small {\n  font-weight: 400;\n  color: var(--gr-muted);\n  font-size: 11.5px;\n}\n\n.gr-barlist-track {\n  height: 8px;\n  border-radius: 999px;\n  background: #efeee9;\n  overflow: hidden;\n}\n\n.gr-barlist-fill {\n  display: block;\n  height: 100%;\n  border-radius: 999px;\n  min-width: 3px;\n}\n\n.gr-barlist-secondary {\n  font-size: 12px;\n  color: var(--gr-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ---------- Sentiment bar ---------- */\n.gr-sentbar-wrap { display: flex; flex-direction: column; gap: 4px; min-width: 90px; }\n\n.gr-sentbar {\n  display: flex;\n  gap: 2px;\n  height: 8px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: #efeee9;\n}\n\n.gr-sentbar span { display: block; height: 100%; min-width: 3px; }\n\n.gr-sentbar-legend {\n  display: flex;\n  gap: 10px;\n  font-size: 11.5px;\n  color: var(--gr-text-2);\n}\n\n/* ---------- Tables ---------- */\n.gr-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.gr-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.gr-table th {\n  padding: 8px 10px;\n  text-align: left;\n  font-size: 11.5px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--gr-muted);\n  border-bottom: 1px solid var(--gr-border-strong);\n  white-space: nowrap;\n}\n\n.gr-table th button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  border: 0;\n  background: none;\n  font: inherit;\n  color: inherit !important;\n  text-transform: inherit;\n  letter-spacing: inherit;\n  cursor: pointer;\n}\n\n.gr-table th button:hover { color: var(--gr-text) !important; }\n\n.gr-table td {\n  padding: 10px;\n  border-bottom: 1px solid var(--gr-border);\n  vertical-align: middle;\n}\n\n.gr-table .is-num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.gr-table th.is-num button { flex-direction: row-reverse; }\n.gr-table td.is-primary { font-weight: 600; }\n.gr-table tr.is-clickable { cursor: pointer; }\n.gr-table tbody tr.is-clickable:hover { background: var(--gr-surface-2); }\n.gr-table tbody tr:last-child td { border-bottom: 0; }\n\n.gr-cell-stack {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n}\n\n.gr-rating-cell { font-weight: 600; white-space: nowrap; }\n\n.gr-share-cell {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.gr-share-track {\n  width: 60px;\n  height: 6px;\n  border-radius: 999px;\n  background: #efeee9;\n  overflow: hidden;\n}\n\n.gr-share-track span {\n  display: block;\n  height: 100%;\n  background: var(--gr-negative);\n}\n\n.gr-person {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ---------- Products ---------- */\n.gr-products {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.gr-products button {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 6px 12px;\n  width: 100%;\n  padding: 10px 8px;\n  border: 0;\n  border-radius: var(--gr-radius-sm);\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n}\n\n.gr-products button:hover { background: var(--gr-surface-2); }\n.gr-products-name { font-weight: 600; }\n.gr-products-stats { font-size: 12.5px; color: var(--gr-text-2); white-space: nowrap; }\n.gr-products .gr-sentbar-wrap { grid-column: 1 / -1; }\n\n/* ---------- Departments ---------- */\n.gr-dept-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 12px;\n}\n\n.gr-dept {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 14px;\n  border: 1px solid var(--gr-border);\n  border-radius: var(--gr-radius);\n  background: var(--gr-surface);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.gr-dept:hover { border-color: rgba(42, 120, 214, 0.45); box-shadow: 0 4px 14px rgba(11, 11, 11, 0.06); }\n\n.gr-dept-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.gr-dept-head strong { font-size: 14.5px; }\n.gr-dept-head span { font-size: 12px; color: var(--gr-muted); white-space: nowrap; }\n\n.gr-dept-metrics {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n\n.gr-dept-metrics > span {\n  display: flex;\n  flex-direction: column;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.gr-dept-metrics small {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--gr-muted);\n}\n\n.gr-dept-foot {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 12px;\n  color: var(--gr-text-2);\n}\n\n/* ---------- Reviews ---------- */\n.gr-reviews-toolbar {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.gr-reviews-controls {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-left: auto;\n}\n\n.gr-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1 1 320px;\n  min-width: 0;\n  height: 40px;\n  padding: 0 10px;\n  gap: 8px;\n  border: 1px solid var(--gr-border-strong);\n  border-radius: var(--gr-radius-sm);\n  background: var(--gr-surface);\n  color: var(--gr-muted);\n}\n\n.gr-search:focus-within { border-color: var(--gr-accent); box-shadow: 0 0 0 3px var(--gr-accent-soft); }\n\n.gr-search input {\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  border: 0;\n  outline: none;\n  background: transparent;\n  font: inherit;\n  color: var(--gr-text);\n}\n\n.gr-search button {\n  display: inline-flex;\n  padding: 4px;\n  border: 0;\n  background: none;\n  cursor: pointer;\n  color: var(--gr-muted) !important;\n}\n\n.gr-search-sm { height: 32px; flex: 0 1 220px; }\n\n.gr-quick-toggles {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.gr-quick-toggles button {\n  padding: 5px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--gr-border-strong);\n  background: var(--gr-surface);\n  font-size: 12.5px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.gr-quick-toggles button:hover { background: var(--gr-surface-2); }\n\n.gr-quick-toggles button.is-active {\n  background: var(--gr-text);\n  border-color: var(--gr-text);\n  color: #fff !important;\n}\n\n.gr-results-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  color: var(--gr-text-2);\n}\n\n.gr-review-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transition: opacity 0.2s;\n}\n\n.gr-review-list.is-loading { opacity: 0.55; }\n\n.gr-review-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.gr-review {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 16px;\n  background: var(--gr-surface);\n  border: 1px solid var(--gr-border);\n  border-left: 3px solid var(--gr-border);\n  border-radius: var(--gr-radius);\n  min-width: 0;\n}\n\n.gr-review-negatywna { border-left-color: var(--gr-negative); }\n.gr-review-pozytywna { border-left-color: var(--gr-positive); }\n.gr-review-neutralna { border-left-color: var(--gr-neutral); }\n\n.gr-review-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.gr-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #e8eef7;\n  color: #1c5cab;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.gr-avatar-sm { width: 26px; height: 26px; font-size: 12px; }\n\n.gr-review-who {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n}\n\n.gr-review-who strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gr-review-who span {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: var(--gr-muted);\n}\n\n.gr-review-score {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.gr-badge {\n  padding: 1px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.gr-badge-pozytywna { background: rgba(42, 120, 214, 0.12); color: #1c5cab; }\n.gr-badge-negatywna { background: rgba(227, 73, 72, 0.12); color: var(--gr-negative-text); }\n.gr-badge-neutralna { background: var(--gr-surface-2); color: var(--gr-text-2); border: 1px solid var(--gr-border); }\n\n.gr-review-text {\n  margin: 0;\n  white-space: pre-line;\n  overflow-wrap: anywhere;\n  color: var(--gr-text);\n}\n\n.gr-review-text.is-clamped {\n  display: -webkit-box;\n  -webkit-line-clamp: 5;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.gr-review-text mark {\n  background: #fff1b8;\n  color: inherit;\n  padding: 0 1px;\n  border-radius: 2px;\n}\n\n.gr-review .gr-link-btn { margin-top: -6px; align-self: flex-start; }\n\n.gr-review-chips,\n.gr-review-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.gr-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 9px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.gr-chip-positive { background: rgba(42, 120, 214, 0.08); color: #1c5cab !important; }\n.gr-chip-negative { background: rgba(227, 73, 72, 0.08); color: var(--gr-negative-text) !important; }\n.gr-chip:hover { border-color: currentColor; }\n\n.gr-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 6px;\n  border: 1px solid var(--gr-border);\n  background: var(--gr-surface-2);\n  font-size: 11.5px;\n  color: var(--gr-text-2) !important;\n}\n\nbutton.gr-tag { cursor: pointer; }\nbutton.gr-tag:hover { border-color: var(--gr-border-strong); color: var(--gr-text) !important; }\n\n.gr-tag-person { background: #eef3fb; }\n.gr-tag-urgency-wysoki { background: rgba(227, 73, 72, 0.1); color: var(--gr-negative-text) !important; border-color: transparent; }\n.gr-tag-urgency-sredni,\n.gr-tag-warn { background: var(--gr-warn-bg); color: var(--gr-warn) !important; border-color: transparent; }\n\n.gr-reply {\n  padding-top: 8px;\n  border-top: 1px dashed var(--gr-border-strong);\n}\n\n.gr-reply .gr-link-btn { margin-top: 0; }\n\n.gr-reply p {\n  margin: 8px 0 0;\n  padding: 10px 12px;\n  border-radius: var(--gr-radius-sm);\n  background: var(--gr-surface-2);\n  font-size: 13px;\n  color: var(--gr-text-2);\n  white-space: pre-line;\n}\n\n/* ---------- Pagination ---------- */\n.gr-pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.gr-pagination button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 36px;\n  height: 36px;\n  padding: 0 8px;\n  border-radius: var(--gr-radius-sm);\n  border: 1px solid var(--gr-border-strong);\n  background: var(--gr-surface);\n  cursor: pointer;\n  font-variant-numeric: tabular-nums;\n}\n\n.gr-pagination button:disabled { opacity: 0.4; cursor: default; }\n.gr-pagination button.is-active { background: var(--gr-text); border-color: var(--gr-text); color: #fff !important; }\n.gr-pagination-gap { padding: 0 4px; color: var(--gr-muted); }\n.gr-pagination-compact { display: none; padding: 0 8px; color: var(--gr-text-2); }\n\n/* ---------- States ---------- */\n.gr-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 32px 16px;\n  text-align: center;\n  color: var(--gr-muted);\n}\n\n.gr-empty strong { color: var(--gr-text-2); }\n.gr-empty p { margin: 0; max-width: 420px; }\n.gr-empty .gr-btn { margin-top: 8px; }\n\n.gr-alert {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding: 10px 14px;\n  margin-bottom: 16px;\n  border-radius: var(--gr-radius-sm);\n}\n\n.gr-alert .gr-btn { margin-left: auto; height: 30px; }\n.gr-alert-error { background: #fdecec; color: #8f1d1d; border: 1px solid #f5c2c2; }\n\n.gr-fatal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  max-width: 480px;\n  margin: 80px auto;\n  padding: 32px;\n  text-align: center;\n  background: var(--gr-surface);\n  border: 1px solid var(--gr-border);\n  border-radius: var(--gr-radius);\n  color: var(--gr-negative-text);\n}\n\n.gr-fatal h2 { margin: 0; font-size: 18px; color: var(--gr-text); }\n.gr-fatal p { margin: 0 0 8px; color: var(--gr-text-2); }\n\n.gr-skel,\n.gr-skeleton-list {\n  border-radius: var(--gr-radius);\n  background: linear-gradient(90deg, #ecebe6 0%, #f5f4f0 50%, #ecebe6 100%);\n  background-size: 200% 100%;\n  animation: gr-shimmer 1.2s linear infinite;\n}\n\n.gr-page-skeleton { display: flex; flex-direction: column; gap: 16px; }\n.gr-skel-header { height: 56px; width: 40%; }\n.gr-skel-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }\n.gr-skel-kpi { height: 120px; }\n.gr-skel-chart { height: 320px; }\n.gr-skeleton-list { height: 220px; }\n\n@keyframes gr-shimmer {\n  from { background-position: 200% 0; }\n  to { background-position: -200% 0; }\n}\n\n/* ---------- Mobile filter sheet ---------- */\n.gr-sheet-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  background: rgba(11, 11, 11, 0.4);\n}\n\n.gr-sheet {\n  width: 100%;\n  max-width: 560px;\n  max-height: 88vh;\n  overflow-y: auto;\n  padding: 16px 16px calc(16px + env(safe-area-inset-bottom));\n  background: var(--gr-surface);\n  border-radius: 16px 16px 0 0;\n  box-shadow: 0 -8px 30px rgba(11, 11, 11, 0.18);\n  animation: gr-sheet-in 0.2s ease-out;\n}\n\n@keyframes gr-sheet-in {\n  from { transform: translateY(24px); opacity: 0; }\n  to { transform: none; opacity: 1; }\n}\n\n.gr-sheet-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  font-size: 16px;\n}\n\n.gr-sheet .gr-field select,\n.gr-sheet .gr-field input {\n  max-width: none;\n  height: 44px;\n  font-size: 16px; /* prevents iOS zoom on focus */\n}\n\n.gr-sheet-foot {\n  position: sticky;\n  bottom: calc(-16px - env(safe-area-inset-bottom));\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 8px;\n  margin: 16px -16px 0;\n  padding: 12px 16px;\n  background: var(--gr-surface);\n  border-top: 1px solid var(--gr-border);\n}\n\n.gr-sheet-foot .gr-btn { height: 44px; }\n\n@media (min-width: 1101px) {\n  .gr-sheet-backdrop { align-items: center; }\n  .gr-sheet { border-radius: 16px; max-width: 480px; }\n  .gr-sheet-foot { position: static; margin-bottom: -16px; border-radius: 0 0 16px 16px; }\n}\n\n/* ==========================================================================\n   Responsive\n   ========================================================================== */\n@media (max-width: 1100px) {\n  .gr-grid-7-5,\n  .gr-grid-8-4 { grid-template-columns: minmax(0, 1fr); }\n  .gr-kpis { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .gr-ministats { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .gr-ministat:nth-child(3) { border-left: 0; }\n  .gr-ministat:nth-child(n + 3) { border-top: 1px solid var(--gr-border); }\n}\n\n@media (max-width: 760px) {\n  .gr-root { padding: 16px; font-size: 14px; }\n  .gr-sticky { margin: 0 -16px 16px; padding: 10px 16px 0; }\n\n  .gr-header { flex-direction: column; align-items: flex-start; gap: 8px; }\n  .gr-header h1 { font-size: 22px; }\n  .gr-header .gr-nowrap { white-space: normal; }\n  .gr-header-meta { align-items: flex-start; text-align: left; }\n\n  .gr-grid-2 { grid-template-columns: minmax(0, 1fr); }\n  .gr-review-grid { grid-template-columns: minmax(0, 1fr); }\n\n  .gr-filterbar { gap: 8px; }\n  .gr-filter-toggle { padding: 0 10px; }\n  .gr-periods button { padding: 7px 10px; }\n  .gr-tabs button { padding: 10px 10px; }\n\n  .gr-card { padding: 14px 14px 16px; }\n  .gr-kpi { padding: 14px 14px 10px; }\n  .gr-kpi-value { font-size: 24px; }\n  .gr-ministat { padding: 10px 14px; }\n  .gr-ministat-value { font-size: 18px; }\n\n  .gr-reviews-controls { margin-left: 0; width: 100%; justify-content: space-between; }\n  .gr-search { flex-basis: 100%; height: 44px; }\n  .gr-search input { font-size: 16px; }\n  .gr-quick-toggles { flex-wrap: nowrap; overflow-x: auto; scrollbar-width: none; margin: 0 -16px; padding: 0 16px; }\n  .gr-quick-toggles::-webkit-scrollbar { display: none; }\n  .gr-quick-toggles button { white-space: nowrap; padding: 7px 12px; }\n\n  .gr-review { padding: 14px; }\n  .gr-pagination button:not(:first-child):not(:last-child) { display: none; }\n  .gr-pagination-gap { display: none; }\n  .gr-pagination-compact { display: inline; }\n  .gr-pagination button { min-width: 44px; height: 44px; }\n\n  .gr-custom-range .gr-field { flex: 1 1 140px; }\n  .gr-custom-range .gr-field input { max-width: none; flex: 1; font-size: 16px; }\n\n  /* Tables become stacked cards. */\n  .gr-table thead { display: none; }\n  .gr-table,\n  .gr-table tbody,\n  .gr-table tr,\n  .gr-table td { display: block; width: 100%; }\n  .gr-table tr {\n    padding: 10px 0;\n    border-bottom: 1px solid var(--gr-border);\n  }\n  .gr-table tbody tr:last-child { border-bottom: 0; }\n  .gr-table td {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding: 3px 4px;\n    border: 0;\n    text-align: right;\n  }\n  .gr-table td::before {\n    content: attr(data-label);\n    flex-shrink: 0;\n    font-size: 12px;\n    color: var(--gr-muted);\n    text-align: left;\n  }\n  .gr-table td.is-primary { font-size: 14.5px; padding-bottom: 6px; }\n  .gr-table td.is-primary::before { display: none; }\n  .gr-table td .gr-sentbar-wrap { flex: 0 1 160px; }\n  .gr-cell-stack { flex-direction: row; align-items: center; gap: 6px; }\n\n  .gr-card-header { flex-wrap: wrap; }\n  .gr-card-header .gr-search-sm { flex: 1 1 100%; }\n  .gr-card-actions:has(.gr-search-sm) { width: 100%; }\n\n  .gr-skel-row { grid-template-columns: repeat(2, 1fr); }\n  .gr-skel-header { width: 70%; }\n}\n\n@media (max-width: 420px) {\n  .gr-kpis { gap: 10px; }\n  .gr-kpi-value { font-size: 22px; }\n  .gr-ratings button { grid-template-columns: 30px minmax(0, 1fr) 34px 78px; gap: 8px; }\n  .gr-dept-grid { grid-template-columns: minmax(0, 1fr); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .gr-root *,\n  .gr-root *::after { animation: none !important; transition: none !important; }\n}\n\n/* ==========================================================================\n   Shared legacy rules – these class names are also used by other pages\n   (Surveys, FeedbackManagement, MeetingStatistics, AdminAnnouncements, Home,\n   InstallationPlanning, ToolAnalytics, AdminPanel, AttachmentPreview).\n   Kept unchanged so removing the old dashboard does not restyle them.\n   ========================================================================== */\n.subtitle {\n  margin: 0.5rem 0 0;\n  opacity: 0.9;\n  font-size: 1.1rem;\n}\n\n.filter-actions {\n  display: flex;\n  align-items: flex-end;\n}\n\n.kpi-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0.25rem 0;\n}\n\n.kpi-label {\n  font-size: 0.875rem;\n  color: #9ca3af;\n}\n\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #e5e7eb;\n  border-top-color: #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-spinner p {\n  margin-top: 1rem;\n  color: #6b7280;\n  font-weight: 600;\n}\n\n.error-message {\n  background: #fee;\n  border: 2px solid #f66;\n  padding: 2rem;\n  border-radius: 12px;\n  text-align: center;\n  max-width: 500px;\n  margin: 2rem auto;\n}\n\n.error-message h3 {\n  color: #dc2626;\n  margin: 0 0 1rem;\n}\n\n.error-message p {\n  color: #991b1b;\n  margin: 0 0 1rem;\n}\n\n/* Recharts defaults shared by every chart in the portal */\n.recharts-cartesian-axis-tick-value {\n  font-size: 0.75rem;\n  fill: #6b7280;\n}\n\n.recharts-legend-item-text {\n  font-size: 0.875rem;\n  color: #374151 !important;\n}\n\n.recharts-tooltip-wrapper {\n  outline: none;\n}\n\n.recharts-default-tooltip {\n  background: white !important;\n  border: 1px solid #e5e7eb !important;\n  border-radius: 8px !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n  padding: 0.75rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
